import classNames from 'classnames';

// import { useId } from 'hooks';
import './index.css';

function Monogram({ highlight, className, ...props }) {
  // const id = useId();
  // const clipId = `monogram-clip-${id}`;

  return (
    <svg
      aria-hidden
      className={classNames('monogram', className)}
      width="50"
      height="35"
      viewBox="0 0 500 500"
      {...props}
    >
      <g transform="translate(0.000000,500.000000) scale(0.100000,-0.100000)">
        <path
          d="M440 3915 l0 -35 178 -2 177 -3 3 -1332 2 -1333 -180 0 -180 0 0 -35
0 -35 560 0 560 0 0 35 0 35 -180 0 -180 0 0 695 0 695 553 -2 552 -3 3 -693
2 -692 -180 0 -180 0 0 -35 0 -35 560 0 560 0 0 35 0 35 -180 0 -180 0 0 1335
0 1335 181 0 180 0 -3 33 -3 32 -557 3 -558 2 0 -35 0 -35 178 -2 177 -3 3
-602 2 -603 -555 0 -555 0 0 605 0 605 181 0 180 0 -3 33 -3 32 -557 3 -558 2
0 -35z"
        />
        <path
          d="M3540 3915 l0 -35 190 0 190 0 -2 -1427 c-3 -1325 -4 -1432 -20
-1479 -23 -65 -62 -116 -113 -146 -35 -20 -53 -23 -145 -23 -118 0 -183 21
-235 75 l-27 28 54 16 c88 25 138 96 138 196 0 65 -18 108 -63 147 -42 37 -88
48 -152 39 -130 -20 -187 -190 -115 -341 53 -111 189 -211 319 -235 113 -21
279 -7 402 35 178 61 284 179 342 383 l22 77 3 1328 3 1327 154 0 155 0 0 35
0 35 -550 0 -550 0 0 -35z"
        />
      </g>
    </svg>
  );
}

export default Monogram;
